var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"QrCodeWrapper",staticClass:"flex justify-center"})
}
var staticRenderFns = []

export { render, staticRenderFns }